import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'enumTransform'
})
export class EnumTransformPipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): unknown {
    switch (value) {

      case 'Published': {
        return 'Publicat';
      }
      case 'Pending_review': {
        return 'In asteptare';
      }
      case 'Draft': {
        return 'Ciorna';
      }
      case 'Expired': {
        return 'Expirat';
      }
      case 'Archived': {
        return 'Arhivat';
      }
      case 'Confidential': {
        return 'Confidential';
      }
      case 'volunteer': {
        return 'Voluntar';
      }
      case 'project': {
        return 'Pe baza de proiect';
      }
      case 'temporary': {
        return 'Temporar';
      }
      case 'part_time': {
        return 'Part Time';
      }
      case 'practice': {
        return 'Practica';
      }
      case 'full_time': {
        return 'Full Time';
      }
      case 'employment': {
        return 'Angajare';
      }
      case 'contractor': {
        return 'Contractant';
      }
      case 'student': {
        return 'Student';
      }
      case 'entry_level': {
        return 'Incepator';
      }
      case 'junior': {
        return 'Junior';
      }
      case 'specialist': {
        return 'Specialist';
      }
      case 'senior': {
        return 'Senior';
      }
      case 'executive': {
        return 'Executiv';
      }
      case 'confidential': {
        return 'Confidential';
      }
      case 'not_offered': {
        return 'Nu se ofera';
      }
      case 'monthly': {
        return 'Lunar';
      }
      case 'quarterly': {
        return 'Semestrial';
      }
      case 'annual': {
        return 'Anual';
      }
      case 'another_interval': {
        return 'Alt interval';
      }
      case 'male': {
        return 'Barbat';
      }
      case 'female': {
        return 'Femeie';
      }
      case 'other': {
        return 'Alta varianta';
      }
      case 'yes': {
        return 'Da';
      }
      case 'no': {
        return 'Nu';
      }
      case true: {
        return 'Da';
      }
      case false: {
        return 'Nu';
      }
      case 'alone_in_romania': {
        return 'Singur in romania';
      }
      case 'alone_in_eu': {
        return 'Singur in UE';
      }
      case 'with_family_in_romania': {
        return 'Cu familia in Romania';
      }
      case 'with_family_in_eu': {
        return 'Cu familia in UE';
      }
      case 'not_require': {
        return 'Nu este necesar';
      }
      case 'unmarried': {
        return 'Necasatorit/a';
      }
      case 'married': {
        return 'Casatorit/a';
      }
      case 'divorced': {
        return 'Divortat/a';
      }
      case 'widower': {
        return 'Vaduv/a';
      }
      case 'high_school': {
        return 'Liceu';
      }
      case 'college': {
        return 'Colegiu / postiliceala';
      }
      case 'faculty': {
        return 'Facultate';
      }
      case 'master': {
        return 'Master';
      }
      case 'doctorate': {
        return 'Doctorat';
      }
      case 'fixed': {
        return 'Fix';
      }
      case 'flexible': {
        return 'Flexibil';
      }
      case 'exchanges': {
        return 'In schimburi';
      }
      case 'weekend_work': {
        return 'In weekend';
      }
      case 'maximum_100_km': {
        return 'Maxim 100km';
      }
      case 'maximum_500_km': {
        return 'Maxim 500km';
      }
      case 'additional': {
        return 'Aditional';
      }
      case 'maximum_10_kg': {
        return 'Maxim 10 kg';
      }
      case 'maximum_25_kg': {
        return 'Maxim 25 kg';
      }
      case 'maximum_50_kg': {
        return 'Maxim 50 kg';
      }
      case 'low_temperature': {
        return 'Temperaturi scazute';
      }
      case 'high_temperature': {
        return 'Temperaturi ridicate';
      }
      case 'immediate': {
        return 'Imediat';
      }
      case 'in_30_days': {
        return 'In 30 de zile';
      }
      case 'in_90_days': {
        return 'In 90 de zile';
      }
      case 'in_6_months': {
        return 'In 6 luni';
      }
      case 'in_9_months': {
        return 'In 9 luni';
      }
      case 'in_12_months': {
        return 'In 12 luni';
      }
      case 'office_job': {
        return 'Munca de birou';
      }
      case 'field_job': {
        return 'Munca de teren';
      }
      case 'remote': {
        return 'Munca de la distanta';
      }
      case 'client': {
        return 'Companie';
      }
      case 'candidate': {
        return 'Candidat';
      }
      case 'applicationResponseNotSent': {
        return 'Aplicatia nu a primit raspuns';
      }
      case 'answerReceived': {
        return 'Raspuns primit';
      }
      case 'interviewPlanned': {
        return 'Interviu planificat';
      }
      case 'applicationEnded': {
        return 'Aplicatie inchisa';
      }
      case 'noAnswerReceived': {
        return 'Nu are raspuns';
      }
      case 'requested': {
        return 'Cerut';
      }
      case 'draft': {
        return 'Ciorna';
      }
      case 'sent': {
        return 'Trimis';
      }
      case 'declined': {
        return 'Respins';
      }
      case 'archived': {
        return 'Arhivat';
      }
      case 'application_for_approval': {
        return 'Aplicatie pentru aprobare';
      }
      case 'pending': {
        return 'In prelucrare';
      }
      case 'accepted': {
        return 'Acceptat';
      }
      case 'pending_payment': {
        return 'Plata trimisa';
      }
      case 'payment_done': {
        return 'Plata finalizata';
      }
      case 'driverLicense': {
        return 'Permis de  conducere';
      }
      case 'country': {
        return 'Tara';
      }
      case 'city': {
        return 'Oras';
      }
      case 'relocationPossibility': {
        return 'Posibilitate relocare';
      }
      case 'relocationPackageIncluded': {
        return 'Facilitati relocare';
      }
      case 'workType': {
        return 'Tip job';
      }
      case 'contractType': {
        return 'Tip contract';
      }
      case 'experienceLevel': {
        return 'Nivel experienta';
      }
      case 'jobDisponibility': {
        return 'Disponibilitate job';
      }
      case 'studies': {
        return 'Studii';
      }
      case 'driveLicense': {
        return 'Permis de  conducere';
      }
      case 'availableForTraveling': {
        return 'Disponibilitate deplasare';
      }
      case 'confidentialSalaryLevel': {
        return 'Nivel Salarial confidential';
      }
      case 'minimumSalaryLevel': {
        return 'Nivel Salarial Minim Net';
      }
      case 'bonus': {
        return 'Bonus';
      }
      case 'averageBonusValue': {
        return 'Valoare medie a bonusului';
      }
      case 'otherBenefits': {
        return 'Alte beneficii';
      }
      case 'careerPossibility': {
        return 'Posibilitati cariera';
      }
      case 'workProgram': {
        return 'Program de lucru';
      }
      case 'workSpace': {
        return 'Spatiu de lucru';
      }
      case 'physicalType': {
        return 'Efort fizic';
      }
      case 'multinational': {
        return 'Multinationala'
      }
      case 'entrepreneurial': {
        return 'Antreprenoriala'
      }
      case 'state': {
        return 'De stat'
      }
      case 'mixed': {
        return 'Mixta'
      }
      case 'medium': {
        return 'Mediu'
      }
      case 'small': {
        return 'Micro'
      }
      case 'currentPositionUpgrade': {
        return 'Crestere in pozitia actuala'
      }
      case 'otherPositionInCountry': {
        return 'Alte pozitii in tara'
      }
      case 'otherPositionOutsideCountry': {
        return 'Alte pozitii in afara tarii'
      }
      case 'superiorPosition': {
        return 'Pozitie ierarhica superioara'
      }
      case 'ROLE_marketing_manager': {
        return 'Marketing Manager'
      }
      case 'ROLE_marketing_operational': {
        return 'Marketing Operational'
      }
      case 'ROLE_project_sales_manager': {
        return 'Sales Project Manager'
      }
      case 'ROLE_manager_sales': {
        return 'Sales Manager'
      }
      case 'ROLE_operational_sale': {
        return 'Sales Operational'
      }
      case 'ROLE_recruiter_project_manager': {
        return 'Recrutare Project Manager'
      }
      case 'ROLE_recruiter_manager': {
        return 'Recrutare Manager'
      }
      case 'ROLE_recruiter_operational': {
        return 'Recrutare Operational'
      }
      case 'ROLE_super_admin': {
        return 'Super Admin'
      }
      case 'contactForm': {
        return 'Formular contact'
      }
      case 'procedure': {
        return 'Procedura'
      }
      case 'recommendation': {
        return 'Recomandare'
      }
      case 'new': {
        return 'Nou'
      }
      case 'read': {
        return 'Vazuta'
      }
      case 'noAnswerReceived': {
        return 'In asteptare'
      }
      case 'applicationRejected': {
        return 'Aplicatie respinsa'
      }
      case 'interviewPlanned': {
        return 'Interviu planificat'
      }
      case 'new': {
        return 'Nou'
      }
      case 'in_progress': {
        return 'In progres'
      }
      case 'done': {
        return 'Rezolvat'
      }
      default: {
        return value;
      }
    }
  }
}
